export const getRandomInRange = (min, max) => {
  return Math.random() * (max - min) + min;
};

export const getRandomColor = () => {
  const colors = [
    '#ff6b6b', '#fca5f1', '#b28dff', '#5efce8', '#64dfdf',
    '#80ffdb', '#7bff7b', '#fff47b', '#ffaa5e', '#ff85a1'
  ];
  return colors[Math.floor(Math.random() * colors.length)];
};

// サイバーグリーン系パレット
export const getCyberGreenColor = () => {
  // 彩度や明度違いの蛍光グリーンをランダムで返す
  const greens = [
    '#39ff14', // ネオングリーン
    '#00ff99',
    '#00ff66',
    '#00ffcc',
    '#00ffb3',
    '#00ff44',
    '#1aff6b',
    '#00e676',
    '#66ff66'
  ];
  return greens[Math.floor(Math.random() * greens.length)];
};
